import main from '@/view/eating/main'

export default [{
    name: 'eating',
    path: '/eating',
    redirect: '/eating/home',
    component:main,
    meta: {
        title: '能不能吃'
    },
    children: [{
        name: 'home',
        path: 'home',
        component: () => import('@/view/eating/home'),
        meta: {
            title: '能不能吃',
        },
    },{
        name: 'list',
        path: 'list',
        component: (resolve) => require(['@/view/eating/list'],resolve),
        meta: {
            title: '食物列表',
            keepAlive: true
        },
    },{
        name: 'details',
        path: 'details',
        component: () => import('@/view/eating/details'),
        meta: {
            title: '食物详情',
        },
    },{
        name: 'feedback',
        path: 'feedback',
        component: () => import('@/view/eating/feedback'),
        meta: {
            title: '意见反馈',
        },
    }]
}]